import { render, staticRenderFns } from "./CampaignIndex.vue?vue&type=template&id=96a7953c"
import script from "./CampaignIndex.vue?vue&type=script&lang=js"
export * from "./CampaignIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports